<nida-web-site-wrapper headline="Register new user" [enableBackButton]="true">
  <nida-web-card [disableHeadline]="true">
    <nida-web-user-detail #userDetail [personal]="undefined" (cancelEdit)="cancel()" (save)="saveChanges()"> </nida-web-user-detail>
  </nida-web-card>
</nida-web-site-wrapper>
